<template>
  <div class="row">
    <div class="col-lg-4 col-xl-3 mb-4 mb-xl-0">
      <section class="card">
        <div class="card-body">
          <div class="thumb-info mb-3">
            <img
              v-if="!posterUrl && !profile.userData.profileImageUrl"
              src="img/!logged-user.jpg"
              class="rounded img-fluid img-profile"
              alt="John Doe"
            />
            <img
              v-if="posterUrl"
              :src="posterUrl"
              class="rounded img-fluid img-profile"
              alt="John Doe"
            />

            <img
              v-if="!posterUrl && profile.userData.profileImageUrl"
              :src="`${baseUrl}${profile.userData.profileImageUrl}`"
              class="rounded img-fluid img-profile"
              alt="John Doe"
            />
            <div class="thumb-info-title" v-if="profile.userData.firstName">
              <span class="thumb-info-inner">{{ `${profile.userData.firstName.toUpperCase()} ${profile.userData.lastName.toUpperCase()}` }}</span>
              <!-- <span class="thumb-info-type">CEO</span> -->
            </div>
          </div>

          <div class="form-group row align-items-center mb-3">
            <div class="col-12">
            <input
              type="file"
              class="form-control"
              ref="photo"
              @change="handlePhotoUpload"
              accept="image/*"
            />

            <button v-if="posterUrl" type="button" class="mt-3 me-1 btn btn-primary btn-lg btn-block w-100" @click.prevent="savePhoto">{{ translations.save }}</button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="col-lg-8 col-xl-9">
      <div class="tab-content">
        <form class="p-3" @submit.prevent="submitForm">
          <h4 class="mb-3 font-weight-semibold text-dark">
            Lične informacije
          </h4>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="inputCity">Ime</label>
              <input type="text" class="form-control" v-model="profile.userData.firstName" required/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="inputCity">Prezime</label>
              <input type="text" class="form-control" v-model="profile.userData.lastName" required/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="inputCity">Telefon</label>
              <input type="text" class="form-control" v-model="profile.userData.phoneNumber"/>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Država</label>
                <select class="form-control" v-model="profile.userData.countryId" @change="getTowns" required>
                  <option :value="null">Izaberite državu</option>
                  <option :value="country.id" :key="country.id" v-for="country in countries">{{ country.title }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Grad</label>
                <select class="form-control" v-model="profile.userData.townId" required>
                  <option :value="null">Izaberite grad</option>
                  <option :value="town.id" :key="town.id" v-for="town in towns">{{ town.title }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="inputCity">Adresa 1</label>
              <input type="text" class="form-control" v-model="profile.userData.address_1"/>
            </div>
            <div class="form-group col-md-6 border-top-0 pt-0">
              <label>Adresa 2</label>
              <input type="text" class="form-control" v-model="profile.userData.address_2"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label>Djelatnosti</label>
              <treeselect
                v-model="profile.userData.interestsAreas"
                :multiple="true"
                :options="areas"
                placeholder="Izaberite djelatnost"
                v-if="areas"/>
            </div>
          </div>

          <hr class="dotted tall"/>

          <h4 class="mb-3 font-weight-semibold text-dark">
            Podaci o dostavi
          </h4>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="inputCity">Ime</label>
              <input type="text" class="form-control" v-model="profile.shippingInfoData.firstName" required/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="inputCity">Prezime</label>
              <input type="text" class="form-control" v-model="profile.shippingInfoData.lastName" required/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="inputCity">Telefon</label>
              <input type="text" class="form-control" v-model="profile.shippingInfoData.phone"/>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Država</label>
                <select class="form-control" v-model="profile.shippingInfoData.countryId" @change="getShippingTowns" required>
                  <option :value="null">Izaberite državu</option>
                  <option :value="country.id" :key="country.id" v-for="country in countries">{{ country.title }}</option>
                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Grad</label>
                <select class="form-control" v-model="profile.shippingInfoData.townId" required @change="setZipCode">
                  <option :value="null">Izaberite grad</option>
                  <option :value="town.id" :key="town.id" v-for="town in towns">{{ town.title }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="inputCity">Adresa 1</label>
              <input type="text" class="form-control" v-model="profile.shippingInfoData.address_1"/>
            </div>
            <div class="form-group col-md-6 border-top-0 pt-0">
              <label>Adresa 2</label>
              <input type="text" class="form-control" v-model="profile.shippingInfoData.address_2"/>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12">
              <label for="inputCity">Poštanski kôd</label>
              <input type="text" class="form-control" v-model="profile.shippingInfoData.zipCode"/>
            </div>
          </div>

          <hr class="dotted tall" />

          <h4 class="mb-3 font-weight-semibold text-dark">
            Informacije o nalogu
          </h4>

          <div class="row">
            <div class="form-group col-md-12"
              :class="{ 'has-danger': usernameExists }"
            >
              <label for="inputCity">Korisničko ime</label>
              <input type="text" class="form-control" v-model="profile.userData.userName" 
                :disabled="canManageCredentials === false" 
                @blur="checkIfUsernameExists"
                />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-12"
              :class="{ 'has-danger': emailExists }"
            >
              <label for="inputCity">E-mail adresa</label>
              <input type="email" class="form-control" v-model="profile.userData.email"
                :disabled="canManageCredentials === false" 
                @blur="checkIfEmailExists"
                />
            </div>
          </div>

          <hr class="dotted tall" />

          <h4 class="mb-3 font-weight-semibold text-dark">
            Promjena lozinke
          </h4>

          <div class="row">
            <div class="form-group col-md-12">
              <label>Trenutna lozinka</label>
              <input
                type="password"
                class="form-control"
                placeholder="Trenutna lozinka"
                v-model="oldPassword"
                :required="newPassword.length > 0 || confirmPassword.length > 0"
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label>Nova lozinka</label>
              <input
                type="password"
                class="form-control"
                placeholder="Nova lozinka"
                v-model="newPassword"
                :required="oldPassword.length > 0"
              />
            </div>
            <div class="form-group col-md-6 border-top-0 pt-0">
              <label for="inputPassword5">Potvrda lozinke</label>
              <input
                type="password"
                class="form-control"
                id="inputPassword5"
                placeholder="Potvrda lozinke"
                v-model="confirmPassword"
                :required="oldPassword.length > 0 || newPassword.length > 0"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 text-end mt-3">
              <button class="btn btn-primary modal-confirm">{{ translations.save }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import { translations } from '@/mixins';
import api from '@/services/api';
import config from '@/config';

export default {
  name: 'UserProfile',
  mixins: [translations],
  components: { Treeselect },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      posterUrl: '',
      baseUrl: config.baseUrl,
      usernameExists: false,
      emailExists: false
    };
  },
  computed: {
    profile() {
      return this.$store.getters.getProfile;
    },
    countries() {
      return this.$store.getters.getCountries;
    },
    towns() {
      return this.$store.getters.getTowns;
    },
    shippingTowns() {
      return this.$store.getters.getShippingTowns;
    },
    canManageCredentials() {
      return (this.$store.getters.getLoggedUser.permissions ?? []).includes(
        'Može ažurirati korisničke kredencijale'
      );
    },
    areas() {
      return this.$store.getters.getInterestsAreas
        .map((item) => {
          return {
            id: item.id,
            label: item.title,
          };
        });
    },
  },
  methods: {
    savePhoto() {
      const formData = new FormData();
      if (this.$refs.photo.files[0]) {
        formData.append('ProfileImage', this.$refs.photo.files[0]);
        api.updateProfileImage(formData).then(() => {
          // Reload current route
          this.$router.go();
        });
      }
    },
    checkIfUsernameExists() {
      api.checkUsername({
        userId: this.profile.userData.id,
        username: this.profile.userData.userName
      })
        .then((response) => {
          this.usernameExists = response.data.data;

          if (this.usernameExists)
            this.$toast.error('Korisničko ime se već koristi!');
        })
    },
    checkIfEmailExists() {
      api.checkEmail({
        userId: this.profile.userData.id,
        email: this.profile.userData.email
      })
        .then((response) => {
          this.emailExists = response.data.data;

          if (this.emailExists)
            this.$toast.error('E-mail se već koristi!');
        })
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      
      reader.onload = (e) => {
        this.posterUrl = e.target.result;
      };
    },
    getTowns(reset = true) {
      this.$store.dispatch('getTowns', { countryId: this.profile.userData.countryId, sortBy: 'title', isSortAscending: true, retrieveAll: true });
      if (reset) this.profile.userData.townId = null;
    },
    getShippingTowns(reset = true) {
      this.$store.dispatch('getShippingTowns', { countryId: this.profile.shippingInfoData.countryId, sortBy: 'title', isSortAscending: true, retrieveAll: true });
      if (reset) this.profile.shippingInfoData.townId = null;
    },
    setZipCode() {
      const town = this.shippingTowns.find(town => town.id === this.profile.shippingInfoData.townId);
      this.profile.shippingInfoData.zipCode = town?.zipCode;
    },
    submitForm() {
      const { profile, oldPassword, newPassword, confirmPassword } = this;

      if (this.usernameExists || this.emailExists) {
        return;
      }

      if (newPassword) {
        profile.userData.password = newPassword;
        profile.userData.currentPassword = oldPassword;
      }

      if (newPassword && newPassword !== confirmPassword) {
        // If password are not same, do nothing
        return;
      }

      const profilePromise = api.updateProfile(profile.userData);
      const shippingInfoPromise = api.updateShippingInfoProfile(profile.shippingInfoData);

      Promise.all([profilePromise, shippingInfoPromise]).then(() => {
        this.$toast.info('Profile successfully updated');
      }).catch(() => {
        this.$toast.error('Something went wrong');
      });
    },
  },
  mounted() {
    this.$store.dispatch('getProfile').then(() => {
      this.getTowns(false);
      this.getShippingTowns(false);
    });
    this.$store.dispatch('getCountries', { sortBy: 'title', isSortAscending: true, retrieveAll: true });
    this.$store.dispatch('getInterestsAreas', { sortBy: 'title', isSortAscending: true, retrieveAll: true});
  },
};
</script>

<style lang="scss">
.img-profile {
  width: 100%;
}
</style>